import { render } from "./InvoiceDetailTabsPanel.vue?vue&type=template&id=3e63c8bc"
import script from "./InvoiceDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailTabsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__